import { ReactNode, useState } from 'react';
import { createContext } from 'react';

export type NavigationDirection = Direction.Next | Direction.Back | null;

export enum Direction {
  Back = 'back',
  Next = 'next'
}

type directionContext = {
  direction: NavigationDirection;
  handleDirectionChanged: (direction: NavigationDirection) => void;
};

export const NavigationDirectionContext = createContext<directionContext>({
  direction: null,
  handleDirectionChanged: () => null
});

interface Props {
  children: ReactNode;
}

const NavigationDirectionProvider = ({ children }: Props) => {
  const [direction, setDirection] = useState<NavigationDirection>(null);

  const handleDirectionChanged = (direction: NavigationDirection) => {
    setDirection(direction);
  };

  return (
    <NavigationDirectionContext.Provider value={{ direction, handleDirectionChanged }}>
      {children}
    </NavigationDirectionContext.Provider>
  );
};

export default NavigationDirectionProvider;
